import { combineReducers } from '@ngrx/store';
import { ActionReducer } from "@ngrx/store";
import { AppState } from "@store/app-state";
import { constantsReducer } from "./constants";
import { userReducer } from "./user";
import { contactsReducer } from "./contacts";
import { enquiriesReducer } from "./enquiries";
import { matrixClassesReducer } from "./matrix-class";
import { enrolmentsReducer } from "./enrolments";
import { calendarReducer } from "./calendar";
import { workshopsReducer } from "./workshops";
import { tutorAllocationsReducer } from "./tutor-allocations";
import { bookingsReducer } from "./bookings";
import { eventsReducer } from "./events";
import { rolesReducer } from "./roles";
import { transactionsReducer } from "./transactions";
import { commsReducer } from "./comms";

const reducers = {
  constantsReducer,
  userReducer,
  contactsReducer,
  enquiriesReducer,
  matrixClassesReducer,
  enrolmentsReducer,
  calendarReducer,
  workshopsReducer,
  tutorAllocationsReducer,
  bookingsReducer,
  eventsReducer,
  rolesReducer,
  transactionsReducer,
  commsReducer,
}

const combinedReducers: ActionReducer<AppState> = combineReducers(reducers)

export function rootReducer(state: any, action: any) {
  return combinedReducers(state, action)
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/combined-reducer.ts